// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1FEFNBOWYJaCredq5bnOdf","switchButton":"_1qvSA1opWa0flwWnHr7S9d","balloonEditorClass":"_3icCg_IRt6ovDnHdwkp6X2"};